import { GetDetectorNameWithTranslation } from './Functions/GetNameWithTranslation';

export const detectors = [
    {
        name: 'RFMD-100',
        label: GetDetectorNameWithTranslation('', 'wall_mounted'),
        type: 'detector',
        tech: 'wireless',
        refImg: 'rfmd-100.png',
        price: 68.14,
    },
    {
        name: 'RFMD-200',
        label: GetDetectorNameWithTranslation('', 'ceiling_mounted'),
        type: 'detector',
        tech: 'wireless',
        refImg: 'rfmd-200.png',
        price: 76.10,
    },
    {
        name: 'RFPD-100',
        label: GetDetectorNameWithTranslation('', 'flush_mounted'),
        type: 'detector',
        tech: 'wireless',
        refImg: 'rfpd-100.png',
        price: 82.5,
    },
    {
        name: 'RFWD-100',
        label: GetDetectorNameWithTranslation('', 'window_door'),
        type: 'detector',
        tech: 'wireless',
        refImg: 'rfwd-100.png',
        price: 52.31
    }
];